<template>
  <!-- eslint-disable vue/no-v-model-argument  -->
  <tsl-card :cardList="cardList">
    <template v-slot:overview>
      <div id="usage-room-chart"></div>
    </template>
    <template v-slot:topRight>
      <a-select placeholder="全部" dropdownClassName="search-select-dropdown" class="roomSelect">
        <a-select-option value="办公室1">办公室1</a-select-option>
        <a-select-option value="办公室2">办公室2</a-select-option>
        <a-select-option value="办公室3">办公室3</a-select-option>
      </a-select>
      <chart-date-tabs class="data-picker" @tabClick="tabsClick" :data="dateData"></chart-date-tabs>
      <a-range-picker
        v-model:value="dateChecked[tabsChecked]"
        @panelChange="panelChange"
        :picker="tabsChecked"
      />
    </template>
  </tsl-card>
</template>

<script>
import Card from "@/components/tsl-card/index.vue";
import chart from "@/components/charts";
import Tabs from "@/components/chart-date-tabs/index.vue";
import { Select, DatePicker } from "ant-design-vue";
import { onMounted, onUnmounted, reactive, ref } from "vue";
const RangePicker = DatePicker.RangePicker;
export default {
  name: "usage-room",
  components: {
    [Card.name]: Card,
    [Tabs.name]: Tabs,
    [RangePicker.name]: RangePicker,
    [Select.name]: Select,
    ASelectOption: Select.Option
  },
  setup() {
    const dateData = ref(["日", "月", "季度"]);
    const cardList = reactive([
      {
        name: "overview",
        title: "办公室使用率",
        topRight: "topRight"
      }
    ]);
    const tabsChecked = ref("day");
    const dateChecked = reactive({
      day: [],
      month: [],
      quarter: []
    });
    const tabsClick = (index) => {
      if (index === 0) {
        tabsChecked.value = "day";
        source.time = ["1/1", "1/2", "1/3", "1/4", "1/5", "1/6", "1/7"];
        source.count = [15, 17, 14, 16, 28, 25, 36];
      } else if (index === 1) {
        tabsChecked.value = "month";
        source.time = [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "9月",
          "10月",
          "11月",
          "12月"
        ];
        source.count = [15, 17, 14, 16, 28, 25, 36, 14, 16, 28, 25, 36];
      } else if (index === 2) {
        tabsChecked.value = "quarter";
        source.time = ["2021Q1", "2021Q2", "2021Q3", "2021Q4", "2022Q1", "2022Q2", "2022Q3"];
        source.count = [15, 17, 14, 16, 28, 25, 36];
      }
      // chart.setBarStatisticsRanking(chartData, "usage-room-chart");

      echart.value.update({
        // creatChart数据
        dataset: chartData,
        series: [
          {
            chartData,
            type: "bar"
          }
        ]
      });
    };
    const source = reactive({
      time: ["1/1", "1/2", "1/3", "1/4", "1/5", "1/6", "1/7"],
      count: [15, 17, 14, 16, 28, 25, 36]
    });

    const panelChange = (value, mode) => {
      console.log(value, mode);
    };

    const chartData = {
      dimensions: ["time", "count"],
      source
    };
    const echart = ref({});
    onMounted(() => {
      echart.value = chart.setBarInterspaceUsage(chartData, "usage-room-chart");
    });
    onUnmounted(() => {
      echart.value.remove();
    });
    return {
      dateData,
      cardList,
      tabsClick,
      tabsChecked,
      dateChecked,
      panelChange
    };
  }
};
</script>

<style lang="less" scoped>
:deep(.rcon) {
  display: flex;
  .data-picker {
    margin: 0 16px;
  }
}
#usage-room-chart {
  width: 100%;
  height: 326px;
}
.roomSelect {
  width: 100px;
}
</style>
